var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chartData)?_c('Bar',{attrs:{"options":_vm.chartOptions,"data":_vm.chartData,"styles":_vm.styles,"width":_vm.width,"height":_vm.height}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }